import { createFileRoute } from "@tanstack/react-router";
import { queryKeys } from "@/lib/query-keys";
import { fetchProductAreas } from "@/features/product-areas/queries";
import { ProductAreasPage } from "@/features/product-areas/pages/product-areas-page";

export const Route = createFileRoute("/_authed/tenants/$slug/settings/product-areas/")({
  loader: async ({ context }) => {
    const tenantID = context.tenant.id;
    await context.queryClient.ensureQueryData({
      queryKey: queryKeys.productAreas.list(tenantID),
      queryFn: () => fetchProductAreas(tenantID),
    }).catch(() => undefined);
  },
  component: ProductAreasPage,
});
